import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import useCustomerService from "../../services/api/customerService";
import dateFormatter from "../../util/dateFormatter";
import { enums } from "../../constants/enum";
import { RefreshIcon } from "../../assets/icons";
import { Button, Loading, Section } from "../../components";

function SelectedCustomer({ customerId, setSelectedCustomerId }) {
  const navigate = useNavigate();
  const { getCustomerById, queryKey } = useCustomerService();
  const {
    data: customerData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [queryKey, customerId],
    queryFn: () => getCustomerById(customerId),
    enabled: !!customerId,
  });
  if (isLoading) {
    return <Loading isLoading={isLoading} variant="inline" />;
  }

  if (isError) {
    toast.error(
      error?.response?.data?.payload?.message || enums.DEFAULT_ERROR_MESSAGE,
    );
    setSelectedCustomerId((prev) => ({ ...prev, customer: null }));
  }

  return (
    <Section
      title="Customer Details"
      enableBackButton
      onBackButtonClick={() =>
        setSelectedCustomerId((prev) => ({ ...prev, customer: null }))
      }
      backButtonText="Change Customer"
    >
      <div className="data-sec prescription-form-page-selected-customer">
        <div className="left-bx">
          <div className="name">
            <span>Name</span>
            <h2>{customerData?.customer?.nameWithTitle}</h2>
          </div>

          <div className="birthday">
            <span>Birthday</span>
            <p>{dateFormatter(customerData?.customer?.dob)}</p>
          </div>

          <div className="address">
            <span>Address</span>
            <p>
              {customerData?.customer?.addressLine1},{" "}
              {customerData?.customer?.addressLine2},{" "}
              {customerData?.customer?.city}
            </p>
          </div>

          <div className="created">
            <span>Created at</span>
            <p>{dateFormatter(customerData?.customer?.createdAt)}</p>
          </div>

          <div className="type">
            <span>Customer type</span>
            <p>{customerData?.customer?.type}</p>
          </div>
          {customerData?.customer?.type === enums.CUSTOMER_TYPES.EYE_CAMP &&
          customerData?.customer?.campaignId?.name ? (
            <div className="camp">
              <span>Campaign Name</span>
              <p>{customerData?.customer?.campaignId?.name}</p>
            </div>
          ) : null}
        </div>

        <div className="right-bx">
          <div className="id">
            <span>Customer ID</span>
            <p>{customerData?.customer?._id}</p>
          </div>

          <div className="phone">
            <span>Phone number</span>
            <p>{customerData?.customer?.mobileNumber}</p>
          </div>

          <div className="update">
            <span>Last updated at</span>
            <p>{dateFormatter(customerData?.customer?.updatedAt)}</p>
          </div>

          {customerData?.customer?.type === enums.CUSTOMER_TYPES.EYE_CAMP &&
          customerData?.customer?.campaignId?.orderNumberSequencePrefix ? (
            <div className="camp">
              <span>Campaign Id</span>
              <p>
                {customerData?.customer?.campaignId?.orderNumberSequencePrefix}
              </p>
            </div>
          ) : null}
          {customerData?.customer?.type === enums.CUSTOMER_TYPES.EYE_CAMP &&
          customerData?.customer?.campaignId?.place ? (
            <div className="camp">
              <span>Campaign Location</span>
              <p>{customerData?.customer?.campaignId?.place}</p>
            </div>
          ) : null}
        </div>
      </div>
      <Button
        type="button"
        text="Edit Customer Details"
        icon={<RefreshIcon />}
        onClick={() =>
          navigate(`/customers/edit/${customerId}`, { replace: true })
        }
      />
    </Section>
  );
}

export default SelectedCustomer;
